import { FormGroup } from '@mui/material';
import styled from 'styled-components';

export const ClientNamesToggleFormGroup = styled(FormGroup)`
  z-index: ${(props: { $zIndex?: number }) => props.$zIndex || 1};
  transform: translateX(8px);
  position: relative;
`;
